import { Component, OnInit, ViewChild, Directive } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ClienteLogin } from '../../login/cliente_login';
import { SessionTokenService } from "../../../components/common/utils/sessionToken.service";
import { HandleError } from "../../../components/common/utils/handleError.component";
import { correctHeight, detectBody, smoothlyMenu } from "../../../app.helpers";
import { CalendarFechaNacParametros } from "../../../components/common/utils/calendarFechaNacParametros";
import { RenovacionService } from "./renovacion.service";
import { UtilService } from "../../../components/common/utils/util.service";
import { ModalComponent } from "ng2-bs3-modal/ng2-bs3-modal";
import { ConsultarUsuarioMasivos } from "../../../components/common/utils/consultarUsuarioMasivos";
import { DatosGeneralesService } from "../datosGenerales/datos-generales.service";
import { ClienteIndividualEntity } from "../datosGenerales/entities/datos_generales_individual_entity";
import { DetalleViviendaEntity, ContenidosVivienda } from "../datosGenerales/entities/detalle_vivienda";
import { ViviendaEntity } from "../datosGenerales/entities/vivienda_entity";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { UsuarioLoginEntity } from "../../login/usuario_login_entity";
import { FormaPagoEntity } from '../datosGenerales/entities/detalle_vehiculo_entity';

const swal = require("sweetalert2");

declare var jQuery: any;

@Component({
    selector: 'renovacionVivienda',
    providers: [RenovacionService],
    templateUrl: 'renovacion-vivienda.template.html',
    styleUrls: ["renovacion.style.css"]
})

export class RenovacionVivienda implements OnInit {

    usuario: ClienteLogin;
    clienteMasivosIndividual: ClienteIndividualEntity;
    viviendaActual: DetalleViviendaEntity;
    viviendaModificada: DetalleViviendaEntity;
    contenidoNuevo: ContenidosVivienda;
    editar: boolean;
    viviendaSelect: ViviendaEntity;
    @ViewChild('incluirContenido')
    modal: ModalComponent;
    usuarioLogin: UsuarioLoginEntity;
    formaPagoSi:number;

    constructor(private renovacionService: RenovacionService,
        public utilsService: UtilService,
        private router: Router,
        private sessionTokenService: SessionTokenService,
        private handleError: HandleError,
        private consultarMasivo: ConsultarUsuarioMasivos,
        private datosGeneralesIndividualSevice: DatosGeneralesService,
        public sesionStorageService: SessionStorageService) { }

    ngOnInit() {
        try {
            /*correctHeight();
            detectBody();*/
            this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
            if (this.usuario == null) {
                let error = { "status": 998, "message": "Acceso denegado" };
                this.handleError.redirectUrl(error)
            } else {
                let bandera = this.sessionTokenService.useJwtHelper();
                if (!bandera) {
                    this.consultarMasivo.iniciarUsuarioMasivo();
                    this.datosGeneralesIndividualSevice.datosClienteIndividual().subscribe(
                        datosClienteIndividual => {
                            this.clienteMasivosIndividual = datosClienteIndividual;
                            this.sesionStorageService.store("NombreUser", JSON.stringify(this.clienteMasivosIndividual.Nombres + " " + this.clienteMasivosIndividual.ApellidoPaterno + " " + this.clienteMasivosIndividual.ApellidoMaterno));
                            sessionStorage.setItem("NombreUser", this.clienteMasivosIndividual.Nombres + " " + this.clienteMasivosIndividual.ApellidoPaterno + " " + this.clienteMasivosIndividual.ApellidoMaterno);
                        },
                        error => { this.handleError.redirectUrl(error); });
                    this.viviendaActual = new DetalleViviendaEntity();
                    this.viviendaModificada = new DetalleViviendaEntity();
                    this.viviendaActual.FormaPago= new FormaPagoEntity();
                    this.contenidoNuevo = new ContenidosVivienda();
                    this.editar = true;
                    this.viviendaSelect = jQuery.parseJSON(this.sesionStorageService.retrieve("ViviendaSeleccionada"));

                    this.getVivienda();
                    this.sesionStorageService.observe("ViviendaSeleccionada").subscribe(v => {
                        this.viviendaSelect = jQuery.parseJSON(v);
                        this.getVivienda();
                    });
                } else {
                    this.usuarioLogin = jQuery.parseJSON(sessionStorage.getItem("usuarioLogin"));
                    let bandera = this.usuarioLogin.Tipo;
                    this.router.navigate(["/login"],bandera);
                }
            }
        } catch (e) {
            this.usuarioLogin = jQuery.parseJSON(sessionStorage.getItem("usuarioLogin"));
            let bandera = this.usuarioLogin.Tipo;
            this.router.navigate(["/login"],bandera);
        }
    }
    getVivienda() {
        this.renovacionService.datosVivienda(this.viviendaSelect).subscribe(
            vivienda => {
                this.viviendaActual = vivienda;
                this.viviendaModificada = this.cloneVivienda(vivienda);            
                this.viviendaActual.Contenidos = new Array<ContenidosVivienda>();
                this.viviendaModificada.Contenidos = new Array<ContenidosVivienda>();
                this.viviendaActual.CodigoUsuarioExtranet = this.usuario.CodigoUsuario;
                this.viviendaModificada.CodigoUsuarioExtranet = this.usuario.CodigoUsuario;
                this.formaPagoSi=1;
                this.viviendaModificada.CodigoVivienda = this.viviendaSelect.CodVivienda;
            },
            error => { this.handleError.redirectUrl(error); }
        )
    }

    editarCampos() {
        this.editar = false;
    }

    cancelarEditarCampos() {
        this.editar = true;
        this.viviendaModificada = this.cloneVivienda(this.viviendaActual);
        this.viviendaModificada.CodigoUsuarioExtranet = this.usuario.CodigoUsuario;
    }

    renovarVivienda() {
        this.viviendaModificada.MantenerFormaPago = ((this.formaPagoSi == 1) ? true : false);
        this.renovacionService.insertarViviendaRenovacion(this.viviendaModificada).subscribe(
            result => {
                if (result) {
                    swal({
                        title: 'Renovación',
                        text: "Recuerde que los datos seran verificados por un ejecutivo, para hacer efectiva su renovación",
                        type: 'success'
                    }).then(function () {
                        window.location.reload(true);
                    });
                } else {
                    swal({
                        title: 'Renovación',
                        text: "A ocurrido un inconveniente al intentar enviar su solicitud",
                        type: 'warning'
                    }).then(function () {
                        this.router.navigate(["/error/500"]);
                    });
                }
            },
            error => { this.handleError.redirectUrl(error); }
        );
    }

    cloneVivienda(c: DetalleViviendaEntity) {
        let vivienda = new DetalleViviendaEntity();
        for (let prop in c) {
            vivienda[prop] = c[prop];
        }
        return vivienda;
    }
    cloneContenido(c: ContenidosVivienda) {
        let contenido = new ContenidosVivienda();
        for (let prop in c) {
            contenido[prop] = c[prop];
        }
        return contenido;
    }

    incluirContenidoVivienda() {
        let codigo = this.contenidoNuevo;
        let valor = this.viviendaModificada.Contenidos.find(function (el) {
            return el.Codigo == codigo.Codigo;
        });
        if (this.contenidoNuevo.Codigo == undefined) {
            this.contenidoNuevo.Codigo = Math.floor((Math.random() * 5000) + 1);
            this.viviendaModificada.Contenidos.push(this.contenidoNuevo);
        } else {
            this.viviendaModificada.Contenidos.forEach(function (e1) {
                if (e1.Codigo == codigo.Codigo) {
                    e1.Marca = codigo.Marca;
                    e1.Modelo = codigo.Modelo;
                    e1.Detalle = codigo.Detalle;
                    e1.Valor = codigo.Valor;
                }
            });
        }
        this.modal.close();
        this.contenidoNuevo = new ContenidosVivienda();
    }

    editarContenido(contenido: ContenidosVivienda) {
        this.contenidoNuevo = new ContenidosVivienda();
        this.contenidoNuevo = this.cloneContenido(contenido);
        this.modal.open();
    }

    eliminarContenido(contenido: ContenidosVivienda) {
        this.viviendaModificada.Contenidos = this.viviendaModificada.Contenidos.filter(function (el) { return el.Codigo !== contenido.Codigo; });
        this.contenidoNuevo = new ContenidosVivienda();
    }

    modalClose() {
        this.contenidoNuevo = new ContenidosVivienda();
        this.modal.close();
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/renovaciones/renovacion-vivienda.component.ts